<script setup>
import HTitle from '~/components/seo/HTitle.vue'
import {useCourseApi} from '~/composables/api/useCourseApi'
import {useProductApi} from '~/composables/api/useProductApi'
import ProductItem from '~/components/partials/ProductItem.vue'
import InlineLoader from '~/components/common/InlineLoader.vue'
import Button from '~/components/common/Button.vue'
import CoursesRequestInfoForm from '~/components/forms/courses/CoursesRequestInfoForm.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => null
  }
})

const courseApi = useCourseApi()
const productApi = useProductApi()
const loading = ref(false)

const blockContent = computed(() => props.data.content)
const haveVSpacing = computed(() => blockContent.value.vSpacing)

const {data: response, error} = await useAsyncData(`block-${props.data.id}-data`, () => {
  try {
    loading.value = true
    const blockContent = props.data.content

    loading.value = false
    return productApi.getListByCategorySlug(blockContent.category_slug, 'id')
  } catch (e) {
    loading.value = false
    return []
  }
})

const hasCourses = computed(() => response.value && response.value.length > 0)
const products = computed(() => response.value)
const containerClasses = computed(() => {
  const columns = blockContent.value?.columns || 12
  return {
    'mb-1': !haveVSpacing.value,
    'mt-3': haveVSpacing.value,
    'col-span-12 sm:col-span-3': columns === 3,
    'col-span-12 sm:col-span-4': columns === 4,
    'col-span-12 sm:col-span-6': columns === 6,
    'col-span-12 sm:col-span-8': columns === 8,
    'col-span-12 sm:col-span-10': columns === 10,
    'col-span-12 sm:col-span-12': columns === 12
  }
})

</script>

<template>
  <div v-if="blockContent" class="grid grid-cols-12 gap-1 course-info" :class="containerClasses">
    <div class="col-span-12 p-8 bg-[#dcd6ce] text-[#363330]">
      <HTitle v-if="blockContent.title" class="text-4xl lg:text-5xl mb-4 text-center !text-[#363330]"
              :type="blockContent.titleH">
        {{ blockContent.title }}
      </HTitle>
      <div v-html="blockContent.description" class="mb-4 text-center"></div>
      <div class="grid grid-cols-12 gap-8 mt-5">
        <div v-if="hasCourses" class="col-span-12 lg:col-span-8 grid grid-cols-12 gap-4">
          <InlineLoader v-show="loading" class="col-span-12" title="Cargando productos"/>
          <ProductItem
            class="col-span-12 lg:col-span-4 xl:col-span-4 flex !justify-start course-info"
            v-for="product in products"
            :product="product"
            :key="product.id"
            :allow-add-to-cart="false"
            :allow-view-details="false"
            :show-prices="false"
          >
            <template v-slot:buttons="slotProps">
              <!--<Button
                severity="tertiary"
                label="+ Info"
              />-->
              <Button
                :to="slotProps.productPath"
                severity="primary"
                label="+ Info"
                class="mb-3 w-full text-center"
              />
            </template>
          </ProductItem>
        </div>
        <div class="col-span-12 lg:col-span-4 bg-white px-4">
          <CoursesRequestInfoForm :courses="products"/>
        </div>
      </div>
    </div>

  </div>
</template>
